import { React, useContext } from "react";
import Config from "../shared/Config";
import RenderMarkups from "../shared/RenderMarkups"
import { GlobalContext } from "../state/GlobalContext"

export default function ThankYouPage(){
    const { state, setState } = useContext(GlobalContext);

    return (
        <div className="thank-you-wrapper">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-12">
                        <div className="thank-you">
                            <p className="small-text">{state.testData.thank_you.small_thank_you_text}</p>
                            <div className="heading-wrapper" dangerouslySetInnerHTML={RenderMarkups(state.testData.thank_you.heading)}></div>
                            <div className="desc-wrapper" dangerouslySetInnerHTML={RenderMarkups(state.testData.thank_you.desc)}></div>
                            <div className="split-buttons-wrapper">
                                <a title={state.testData.thank_you.button_home_label} href={state.testData.thank_you.button_home_link}>{state.testData.thank_you.button_home_label} <i style={{backgroundImage: `url(${Config('ASSETS_URL')+'/images/white-circle-arrow.svg'})`}}></i></a>
                                {/* <a className="darker-button" title={state.testData.thank_you.button_newsletter_label} href={state.testData.thank_you.button_newsletter_link}>{state.testData.thank_you.button_newsletter_label}</a> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <img src={state.testData.thank_you.thank_you_image} alt="Thank you" />
                    </div>
                </div>
            </div>
        </div>
    )
}